module.exports = __webpack_public_path__ + "static/media/meme-floating.07a498d8.png";